jQuery( '.burgerBun' ).click( function() {
  jQuery( '.burgerBun' ).toggleClass( "open" );
  jQuery( '.menu-mobile-menu-container' ).toggleClass( "open" );
} );
jQuery( '.menu-mobile-menu-container a' ).click( function() {
  jQuery( '.burgerBun' ).removeClass( "open" );
  jQuery( '.menu-mobile-menu-container' ).removeClass( "open" );
} );

function isScrollRelevant() {
  return ( jQuery( 'header' ).hasClass( 'homepage' ) || jQuery( 'header + .small-banner' ).get( 0 ) !== undefined );
}

jQuery( window ).on( "scroll resize load", function() {
  if ( isScrollRelevant() ) {
    if ( jQuery( window ).width() > 1024 ) {
      if ( jQuery( document ).scrollTop() > 5 ) {
        jQuery( 'header' ).addClass( 'scroll' );
      } else {
        jQuery( 'header' ).removeClass( 'scroll' );
      }
    } else {
      jQuery( 'header' ).addClass( 'scroll' );
    }
  }
} );



jQuery( document ).ready( function() {
  if ( !isScrollRelevant() ) {
    jQuery( 'body' ).css( 'padding-top', '4.5rem' );
  }
} );